import type { PropertySelectionItem as HmPropertySelectionItem } from "libs/codegen/homes-onbaording";
import type { PropertySelectionItem } from "libs/codegen/property-onboarding";
import { PropertySelectionStatus } from "./constants";

export const selectablePropertiesFilter = (p: HmPropertySelectionItem | PropertySelectionItem) =>
    p.status === PropertySelectionStatus.Importable || p.status === PropertySelectionStatus.ImportableFromRoomUrl;
